// extracted by mini-css-extract-plugin
export var actionsRow = "_1g-a";
export var actionsRowEnd = "_1g-b";
export var askRedoBlackBtn = "_1g-d";
export var askRedoBlackBtnIcon = "_1g-e";
export var exitModalActionBtn = "_1g-c";
export var exitModalRoot = "_1g-0";
export var followUpInput = "_1g-9";
export var modalContentBody = "_1g-7";
export var modalHeaderImage = "_1g-2";
export var modalImageLabel = "_1g-4";
export var modalImageOverlay = "_1g-3";
export var modalImageSubheading = "_1g-6";
export var modalImageTitle = "_1g-5";
export var modalImageWrapper = "_1g-1";
export var reasonCard = "_1g-f";
export var reasonCardSelected = "_1g-g";
export var reasonIcon = "_1g-j";
export var reasonIconWrap = "_1g-i";
export var reasonIndicator = "_1g-l";
export var reasonIndicatorDot = "_1g-n";
export var reasonIndicatorSelected = "_1g-m";
export var reasonLabel = "_1g-h";
export var reasonList = "_1g-8";
export var reasonTitle = "_1g-k";